module.exports = __webpack_public_path__ + "themify.cba68f986e60df8c74f4.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/themify-icons/fonts/themify.svg?-fvbane
// module id = ../../../../../src/scss/icons/themify-icons/fonts/themify.svg?-fvbane
// module chunks = styles